'use client'
import type { NumberInputProps } from '@chakra-ui/react'
import { NumberSelector } from 'ui'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { overrideText } from 'ui/lib/overrides'
import { type QuantityOverrides } from '../../../../types'

type CheckoutCartItemCounterProps = NumberInputProps

export const CheckoutCartItemCounter = (props: CheckoutCartItemCounterProps) => {
  const overrides = useOverridesContext<keyof QuantityOverrides>()

  return (
    <NumberSelector
      minW={16}
      bg="background.default"
      borderRadius="sm"
      hiddenLabel={overrideText('Kvantitet', overrides?.quantity)}
      id="cart-qty"
      size="sm"
      min={1}
      {...props}
    />
  )
}
